import { z } from 'zod'

import { PaymentProfileStatus } from '../constants/paymentProfile'
import { PaymentProvider } from '../constants/pricing'
import { dbEntitySchema } from './system'
import { paymentInstrumentSnapshotSchema } from './paymentInstrument'

export const paymentProfileAddressSchema = z.object({
  address: z.string().trim().optional().nullable(),
  extendedAddress: z.string().trim().optional().nullable(),
  city: z.string().trim().optional().nullable(),
  state: z.string().trim().optional().nullable(),
  zip: z.string().trim().optional().nullable(),
})

export const paymentProfileSchema = dbEntitySchema.extend({
  status: z
    .nativeEnum(PaymentProfileStatus)
    .default(PaymentProfileStatus.ACTIVE),
  user: z.string().optional().nullable(),
  organization: z.string().optional().nullable(),
  prospect: z.string().optional().nullable(),
  cardholderName: z.string().optional().nullable(),
  last4: z.string().optional().nullable(),
  expirationMonth: z.string().optional().nullable(),
  expirationYear: z.string().optional().nullable(),
  paymentMethodType: paymentInstrumentSnapshotSchema.shape.paymentMethodType,
  walletType: paymentInstrumentSnapshotSchema.shape.walletType,
  cardFunding: paymentInstrumentSnapshotSchema.shape.cardFunding,
  cardCountry: paymentInstrumentSnapshotSchema.shape.cardCountry,
  zip: z.string().optional().nullable(),
  address: paymentProfileAddressSchema.optional().nullable(),
  cardType: z.string().optional().nullable(),
  imageUrl: z.string().optional().nullable(),
  default: z.boolean().default(false),
  providerType: z.nativeEnum(PaymentProvider),
  providerPaymentId: z.string(),
  providerCustomerId: z.string().optional().nullable(),
  token: z.string().optional().nullable(),
})

export const paymentProfileCreateArgsSchema = z
  .object({
    userId: z.string().optional().nullable(),
    organizationId: z.string().optional().nullable(),
    prospectId: z.string().optional().nullable(),
    providerToken: z.string(),
    cardholderName: z.string().optional(),
    providerType: z.nativeEnum(PaymentProvider).optional(),
    status: z.nativeEnum(PaymentProfileStatus).optional(),
  })
  .refine(
    ({ userId, organizationId, prospectId }) =>
      Boolean(userId || organizationId || prospectId),
    {
      message: 'one owner id is required',
      path: ['userId'],
    }
  )

export const paymentProfileListByOwnerArgsSchema = z
  .object({
    userId: z.string().optional().nullable(),
    organizationId: z.string().optional().nullable(),
    prospectId: z.string().optional().nullable(),
    providerType: z.nativeEnum(PaymentProvider).optional(),
  })
  .refine(
    ({ userId, organizationId, prospectId }) =>
      Boolean(userId || organizationId || prospectId),
    {
      message: 'one owner id is required',
      path: ['userId'],
    }
  )

export const paymentProfilePersistArgsSchema = z.object({
  user: z.string().optional().nullable(),
  organization: z.string().optional().nullable(),
  prospect: z.string().optional().nullable(),
  cardholderName: z.string().optional().nullable(),
  last4: z.string().optional().nullable(),
  expirationMonth: z.string().optional().nullable(),
  expirationYear: z.string().optional().nullable(),
  paymentMethodType: paymentInstrumentSnapshotSchema.shape.paymentMethodType,
  walletType: paymentInstrumentSnapshotSchema.shape.walletType,
  cardFunding: paymentInstrumentSnapshotSchema.shape.cardFunding,
  cardCountry: paymentInstrumentSnapshotSchema.shape.cardCountry,
  zip: z.string().optional().nullable(),
  address: paymentProfileAddressSchema.optional().nullable(),
  cardType: z.string().optional().nullable(),
  imageUrl: z.string().optional().nullable(),
  default: z.boolean().default(false),
  providerType: z.nativeEnum(PaymentProvider),
  providerPaymentId: z.string(),
  providerCustomerId: z.string().optional().nullable(),
  token: z.string().optional().nullable(),
  status: z
    .nativeEnum(PaymentProfileStatus)
    .default(PaymentProfileStatus.ACTIVE),
})

export const paymentProfileUpdateByIdArgsSchema = z.object({
  cardholderName: z.string().optional(),
  last4: z.string().optional(),
  expirationMonth: z.string().optional(),
  expirationYear: z.string().optional(),
  paymentMethodType: z.string().optional(),
  walletType: z.string().optional(),
  cardFunding: z.string().optional(),
  cardCountry: z.string().optional(),
  zip: z.string().optional(),
  address: paymentProfileAddressSchema.optional(),
  cardType: z.string().optional(),
  imageUrl: z.string().optional(),
  default: z.boolean().optional(),
  status: z.nativeEnum(PaymentProfileStatus).optional(),
  providerCustomerId: z.string().optional(),
  token: z.string().optional(),
})
